// ライブラリ読み込み用ファイル
// expose-loaderを通してインポートすることでグローバルオブジェクトにする

import 'expose-loader?exposes[]=$&exposes[]=jQuery!jquery' // jQuery

// import 'expose-loader?exposes[]=Cookies!js-cookie' // Cookie

// import 'expose-loader?exposes[]=React!react' // React
// import 'expose-loader?exposes[]=ReactDOM!react-dom' // ReactDOM

// import 'expose-loader?exposes[]=slick!slick-carousel' // Slick
// import 'expose-loader?exposes[]=baguetteBox!baguettebox.js' // BaguetteBox

// import 'expose-loader?exposes[]=lozad!lozad' // Lozad.js Intersection Observer
// ↑要 Intersection Observerポリフィル
// <script src="https://polyfill.io/v2/polyfill.min.js?features=IntersectionObserver"></script>

// import 'expose-loader?exposes[]=YTPlayer!jquery.mb.ytplayer' // YTPlayer

// import 'trunk8' // Trunk8

// import 'expose-loader?exposes[]=Stickyfill!stickyfilljs' // position:styckyのポリフィル

// import 'expose-loader?exposes[]=InfiniteScroll!infinite-scroll' // InfiniteScroll

// import 'pickadate/lib/picker' // pickadate　コアファイル
// import 'pickadate/lib/picker.date' // pickadate　デートピッカー
// import 'pickadate/lib/picker.time' // pickadate　タイムピッカー

import './module/_hashScroll' // アンカーリンクスクロール
import './module/_spMenuToggle' // SPメニュー開閉
